import { render, staticRenderFns } from "./PaginaVistaExpedienteQR.vue?vue&type=template&id=3339bd99"
import script from "./PaginaVistaExpedienteQR.vue?vue&type=script&lang=js"
export * from "./PaginaVistaExpedienteQR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports